import { render } from "./passDetailModal.vue?vue&type=template&id=239a0560&scoped=true"
import script from "./passDetailModal.vue?vue&type=script&lang=js"
export * from "./passDetailModal.vue?vue&type=script&lang=js"

import "./passDetailModal.vue?vue&type=style&index=0&id=239a0560&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239a0560"]])

export default __exports__